import instance from './common';

const uri = '/sharing';

/* List all shared states for current customer */
export const list = (reqBody, options = {}, http = instance) => http.get(uri, reqBody, options);

/* Post new shared state */
export const post = (reqBody, options = {}, http = instance) => http.post(uri, reqBody, options);

/* Get shared state by id */
export const get = (id, options = {}, http = instance) => http.get(`${uri}/${encodeURIComponent(id)}`, {}, options);
